import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import Reveal from "../components/Reveal";
import { useLang } from "../i18n/i18n";

export default function Privacy() {
  const { t } = useLang();
  const SECTIONS = [
    "pp.s1t",
    "pp.s2t",
    "pp.s3t",
    "pp.s4t",
    "pp.s5t",
    "pp.s6t",
    "pp.s7t",
    "pp.s8t",
    "pp.s9t",
    "pp.s10t",
  ];

  return (
    <main className="pt-[72px]" data-testid="privacy-page">
      <section className="mx-auto max-w-3xl px-5 sm:px-8 py-16 sm:py-20">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-xs tracking-[0.35em] uppercase text-gold">
            <ShieldCheck size={15} /> {t("pp.eyebrow")}
          </p>
          <h1 className="mt-4 font-display text-4xl sm:text-6xl font-light text-cream leading-tight">{t("pp.h1")}</h1>
          <p className="mt-4 text-xs uppercase tracking-[0.25em] text-mutedc" data-testid="privacy-updated">
            {t("pp.updated")}
          </p>
        </Reveal>

        <div className="mt-12 space-y-5">
          {SECTIONS.map((k, i) => (
            <Reveal key={k} delay={Math.min(i * 0.04, 0.3)} className="h-full">
              <div className="rounded-2xl border border-gold/15 bg-panel/70 p-7">
                <h2 className="font-display text-xl text-goldlight">
                  <span className="text-gold/40 tabular mr-3">{String(i + 1).padStart(2, "0")}</span>
                  {t(`${k.slice(0, -1)}t`)}
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-cream/75">{t(`${k.slice(0, -1)}d`)}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <Link
            to="/"
            data-testid="privacy-back-home"
            className="mt-12 inline-flex items-center gap-2 rounded-full border border-cream/20 px-6 py-3 text-sm text-cream/80 transition-all hover:border-gold hover:text-goldlight"
          >
            <ArrowLeft size={15} /> {t("inv.back")}
          </Link>
        </Reveal>
      </section>
    </main>
  );
}
